import { KeyValuePairCollection } from './kvp.collection';

export const OrderChannel: KeyValuePairCollection<string> = new KeyValuePairCollection<string>([
  { key: 'Machinery Down Order', value: 'MD' },
  { key: 'Stock Order Program', value: 'SO' },
  { key: 'Service Part', value: 'SP' },
  { key: 'Whole Goods', value: 'WG' },
  { key: 'OEM', value: 'OEM' }
]);
